module.exports = __webpack_public_path__ + "img/wine-top-charcuterie-board-food-thumb.jpg";